import { SubTitle } from '~/pages/Main/index.styled';
import { FlexStack } from '~/components/atomic';
import { FullScreenLoading } from '~/components/common';
import HorizontalCardSlide from '~/components/common/HorizontalCardSlide/HorizontalCardSlide';
import { useGetListByCharacterTypeQuery } from '~/features/character';
import { useCharacterLikeActions, useCreateChatRoom } from '~/hooks';

export default function ForYouCharacters() {
  const { data } = useGetListByCharacterTypeQuery({ type: 'celeb' });

  const { handleCreateRoomClick, isCreateRoomPending } = useCreateChatRoom();
  const { handleLikeClick } = useCharacterLikeActions();

  return (
    <>
      {isCreateRoomPending && <FullScreenLoading />}

      <FlexStack spacing={16}>
        <div>
          <SubTitle>Chat with your own celeb</SubTitle>
        </div>
        <div>
          <HorizontalCardSlide
            images={data}
            handleCardClick={handleCreateRoomClick}
            handleLikeClick={handleLikeClick}
          />
        </div>
      </FlexStack>
    </>
  );
}
